import { render, staticRenderFns } from "./SetPresence.vue?vue&type=template&id=46d5f3a5&"
import script from "./SetPresence.vue?vue&type=script&lang=js&"
export * from "./SetPresence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports